import {
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'src/app/hooks';
import BottomHeader from './Bottom';
import GroupObject from 'src/components/GroupObject';
import ModalManageObjectByGroup from 'src/components/ModalManageObjectByGroup';
import TooltipCustomize from 'src/components/TooltipCustomize';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EcommerceObjectPreview from 'src/components/EcommerceObjectPreview';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: ${theme.header.background};
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

const HeaderWrapperSec = styled(Box)(
  ({ theme }) => `
    background: #fbfbfb;
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    justify-content: space-between;
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderEcommerceStream() {
  const objectListByObjectType = useAppSelector(
    (state) => state.objectManagement.objectListByObjectType
  );

  const theme = useTheme();
  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <HeaderWrapper display="flex" alignItems="center">
        <Grid container>
          <Grid item lg={12}>
            <Stack direction="row" alignItems="center">
              <Typography
                variant="h1"
                sx={{
                  mr: 1
                }}
              >
                E-commerce Stream
              </Typography>
              <TooltipCustomize
                title={
                  'Monitor all your e-commerce keywords and hashtags streams'
                }
                placement="top-start"
              >
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ transform: 'translateY(-4px)' }}
                />
              </TooltipCustomize>
            </Stack>
          </Grid>
          <Grid item lg={12}>
            <Box mt={2}>
              <GroupObject />
            </Box>
          </Grid>
          <Grid item lg={12}>
            <Stack
              direction={matchesUpSm ? 'row' : 'column'}
              alignItems={matchesUpSm ? 'center' : 'start'}
              spacing={1}
              mt={1.5}
              mb={3}
            >
              <ModalManageObjectByGroup title="Stores" />
              <EcommerceObjectPreview
                objectList={objectListByObjectType ?? []}
              />
            </Stack>
          </Grid>
        </Grid>
      </HeaderWrapper>
      <HeaderWrapperSec display="flex" alignItems="center">
        <Grid container>
          <Grid item lg={12}>
            <BottomHeader />
          </Grid>
        </Grid>
      </HeaderWrapperSec>
    </>
  );
}

export default HeaderEcommerceStream;
